import React, { type ReactElement } from 'react';

import classNames from 'classnames';

import ShareIcon from '~/public/assets/images/svg/share.svg';

export interface ShareButtonProps {
  name: string;
  description?: string;
  pathName: string;
  className?: string;
}

export default function ShareButton({
  name,
  pathName,
  className,
  description,
}: ShareButtonProps): ReactElement {
  const onShareClickHandler = async () => {
    if (typeof navigator !== 'undefined' && 'share' in navigator) {
      navigator.share({
        title: name,
        text: description || '',
        url: window.location.href,
      });
    }
  };
  return (
    <button
      onClick={() => {
        onShareClickHandler();
      }}
      className={classNames(
        'items-center justify-center rounded-[10px] bg-black-600 text-white',
        className
      )}
      aria-label={`Share ${name}`}
    >
      <ShareIcon className="mx-auto h-4 w-4 lg:h-5 lg:w-5" />
    </button>
  );
}
